<template>
  <div class="container">
    <Tbheader
      :tipo="tipo + ' - segmentos'"
      :novo="novo"
      :titulo="contentEdit.titulo"
      :icone="icone"
    />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">

        <div class="col-10 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{ active: contentEdit.ativo == true }"
            >
              <input
                type="radio"
                name="ativo"
                id="ativo"
                @change="fnAtiva()"
                :value="true"
                autocomplete="off"
                class="valid"
              />
              Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{ active: contentEdit.ativo == false }"
            >
              <input
                type="radio"
                name="ativo"
                id="inativo"
                @change="fnAtiva()"
                :value="false"
                autocomplete="off"
                class="valid"

              />
              Não
            </label>
          </div>
        </div>
       <div class="col-10 form-group">
          <label>URL Amigável:</label>
          <input
            type="text"
            v-model="contentEdit.slug"
            name="slug"
            id="slug"
            class="form-control required valid"
            value
            readonly

          />
        </div>
        <div class="col-2 form-group">
          <label>Ordem:</label>
          <input
            type="number"
            v-model="contentEdit.ordem"
            name="ordem"
            id="ordem"
            class="form-control required valid"
            value
          />
        </div>
       <div class="col-sm-12">
            <h4 class="mb-3">Texto</h4>
          <vue-editor class="vEditor" :editor-toolbar="customToolbar" v-model="contentEdit.texto" />
        </div>



        <div class="col-12 form-group"></div>

        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >
            Cancelar
          </button>
          <button
            type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >
            Gravar
          </button>
        </div>
      </div>
    </form>
    <div style="display: none">
      {{ carregadoImg }}
      {{contentEdit}}

    </div>
  </div>
</template>

<script>
import Tbheader from "../_headerTabelas";
import { getData, getSuccess, getError, urlApi } from "../../global/utils";
import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: urlApi,
      suporteAtivo: true,
      success: false,
      error: null,
      contentFotos: [],
      carregado: true,
      carregadoIm: false,
      files: [],
      imagem: [],
      logotipoRodape: [],
      contentEdit: {
        titulo: "",
        ativo: false,
        mostraTitulo: true
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
    };
  },
  components: { Tbheader,VueEditor },
  methods: {
    OnFileSelected(event) {
      if (event.target.id == "imagemCapa") {
        this.contentEdit.imagemCapa = URL.createObjectURL(event.target.files[0]);
        this.imagem = event.target.files[0];
        this.carregado = true;
        this.carregadoIm = true;
      }
    },
    fnRemoveFoto(tipo, i) {
      var filename = "";
      if (i == 1) {
        filename = this.contentEdit.imagemCapa
          .split("/")
          .pop()
          .split("#")[0]
          .split("?")[0];
        this.contentEdit.imagemCapa = null;
      }
      this.$http
        .delete(
          "autoespecialistas/upload/autoespecialistas/segmentos/" +
            filename +
            "/arquivo"
        )
        .then((res) => {
          console.log(res);
        });
    },
    GetFilename(url) {
      if (url) {
        var m = url.toString().match(/.*\/(.+?)\./);
        if (m && m.length > 1) {
          return m[1];
        }
      }
      return "";
    },
    OnUpload() {
      let fd = new FormData();
      if (this.imagem.name != undefined) {
        fd.append("files", this.imagem, this.imagem.name);
      }

      this.$http
        .post("autoespecialistas/upload/autoespecialistas/segmentos", fd)
        .then(() => {
          this.carregado = true;
        });
    },
    fnLimpa() {
      this.contentEdit.titulo = "";
      this.contentEdit.ativo = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
      this.contentEdit.ativo = !this.contentEdit.ativo;
    },
    fnDestaque() {
      this.contentEdit.destaque = !this.contentEdit.destaque;
    },
    fnMostraTitulo() {
        this.contentEdit.mostraTitulo = !this.contentEdit.mostraTitulo;
        console.log(this.contentEdit.mostraTitulo);
    },
    fnCancela() {
      this.$router.push({ path: `/autoespecialistas/segmentos/` });
    },
    async formSubmit(e) {
      e.preventDefault();
      let metodo = null;
      let completaUrl = null;
      if (this.$route.meta.breadcrumb == "Copiar") {
        metodo = "post";
        completaUrl = "/copiar";
      } else {
        metodo = this.$route.params.id ? "put" : "post";
        completaUrl = this.$route.params.id ? "/" + this.$route.params.id : "";
      }

      const imgUrl =
        urlApi + "Upload/autoespecialistas/segmentos/";
      var chamaUpload = false;
      if (this.imagem.name != undefined) {
        chamaUpload = true;
        this.contentEdit.imagemCapa =
          imgUrl + this.imagem.name;
      }

      this.contentEdit.ordemHome = parseInt(this.contentEdit.ordemHome);
      let data = await this.$http[metodo](
        "/autoespecialistas/segmentos" + completaUrl,
        this.contentEdit
      )
        .then(() => {
          getSuccess();
            if (chamaUpload) {
            this.OnUpload();
          }
          if( this.tipo == "Copiando"){
            this.fnCopyFoto();
          }        
          this.fnLimpa();
          this.fnCancela();
        })
        .catch((e) => {
          return e;
        });
      this.error = data;
    },
    fnGetError(e) {
      getError(e);
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        if (this.$route.meta.breadcrumb == "Copiar") {
          this.tipo = "Copiando";
          this.novo = true;
          this.fnCarregaItems(this.$route.params.id);
        } else {
          this.tipo = "Editando";
          this.novo = false;
          this.fnCarregaItems(this.$route.params.id);
        }
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false;
        this.contentEdit.mostraTitulo = true;
        this.contentEdit.imagemCapa = null;
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi + "autoespecialistas/segmentos/" + valueId);
      this.contentEdit = data[0].content;
      console.log(this.contentEdit);
      this.$vs.loading.close();

    },
    fnSlug(value){
      if (value != undefined){
        var valor = this.especialCharMask(value.toLowerCase());
        this.contentEdit.slug = valor
     }

    },
    especialCharMask (especialChar){
        especialChar = especialChar.replace(/ – /g, '-');
        especialChar = especialChar.replace(/[áàãâä]/g, 'a');
        especialChar = especialChar.replace(/[éèêë]/g, 'e');
        especialChar = especialChar.replace(/[íìîï]/g, 'i');
        especialChar = especialChar.replace(/[óòõôöô]/g, 'o');
        especialChar = especialChar.replace(/[úùûü]/g, 'u');
        especialChar = especialChar.replace(/[ç]/g, 'c');
        especialChar = especialChar.replace(/[,]/g, '');
        especialChar = especialChar.replace(/[.]/g, '');
        especialChar = especialChar.replace(/[^a-z0-9]/g, '-');
        
        return especialChar;
    }
  },
  created() {
    this.fnIsEdit();
    setInterval(() => {
      this.fnSlug(this.contentEdit.titulo);
    },1000
    );
  },
  computed: {

    confere: function () {
      return this.fnIsEdit();
    },
    temErro() {
      if (this.error) {
        return this.fnGetError(this.error);
      } else {
        return "";
      }
    },
    carregadoImg() {
      if (this.carregadoIm) {
        return this.contentEdit;
      } else {
        return "";
      }
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
#editor1,
#editor2,
#editor3 {
  min-height: 50vh;
}
</style>